import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Globe, Clock, ArrowRight } from 'lucide-react';
import Hero from '../components/Hero';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact">
      <Hero
        label="Contact"
        title="Get in Touch"
        subtitle="Let's move forward together."
        size="medium"
        image="/img/contact-hero.jpg"
      />

      <section className="section contact-main">
        <div className="container">
          <div className="text-center">
            <span className="section-label">We Are Here to Help</span>
            <h2 className="section-title">Let's Move Forward Together</h2>
            <p className="section-subtitle">
              Whether you require air freight, sea freight, land transportation, project logistics,
              customs clearance, or warehousing solutions, our team is ready to assist you.
            </p>
          </div>

          <div className="contact__grid">
            {/* Contact Info */}
            <div className="contact__info">
              <div className="contact-card">
                <div className="contact-card__icon">
                  <MapPin size={24} />
                </div>
                <div>
                  <h4>Address</h4>
                  <p>
                    Denver Logistics Private Limited<br />
                    Sundarbans, No. 70/16, First Floor,<br />
                    1st Avenue, 100 Feet Road,<br />
                    Ashok Nagar, Chennai - 600 083, India
                  </p>
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-card__icon">
                  <Phone size={24} />
                </div>
                <div>
                  <h4>Phone</h4>
                  <p><a href="tel:+919940689572">+91 99406 89572</a></p>
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-card__icon">
                  <Mail size={24} />
                </div>
                <div>
                  <h4>Email</h4>
                  <p><a href="mailto:info@denver-logistics.com">info@denver-logistics.com</a></p>
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-card__icon">
                  <Globe size={24} />
                </div>
                <div>
                  <h4>Website</h4>
                  <p>www.denver-logistics.com</p>
                </div>
              </div>

              <div className="contact-card">
                <div className="contact-card__icon">
                  <Clock size={24} />
                </div>
                <div>
                  <h4>Business Hours</h4>
                  <p>Monday - Saturday: 9:00 AM - 6:00 PM<br />Sunday: Closed</p>
                </div>
              </div>
            </div>

            {/* Quick Enquiry Form */}
            <div className="contact__form-wrap">
              <h3>Send Us a Message</h3>
              <p>Have a question? Fill out the form and we'll get back to you shortly.</p>
              <form className="contact__form" onSubmit={(e) => e.preventDefault()}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input type="text" id="name" required placeholder="Your name" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="company">Company Name</label>
                    <input type="text" id="company" placeholder="Your company" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input type="email" id="email" required placeholder="your@email.com" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone *</label>
                    <input type="tel" id="phone" required placeholder="+91 XXXXX XXXXX" />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <select id="subject">
                    <option value="">Select a subject</option>
                    <option value="sea-freight">Sea Freight</option>
                    <option value="air-freight">Air Freight</option>
                    <option value="land-freight">Land Freight</option>
                    <option value="project-logistics">Project Logistics</option>
                    <option value="customs">Customs Clearance</option>
                    <option value="warehousing">Warehousing</option>
                    <option value="general">General Enquiry</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea id="message" rows="4" placeholder="How can we help you?"></textarea>
                </div>
                <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%', justifyContent: 'center' }}>
                  Send Message <ArrowRight size={18} />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Placeholder */}
      <section className="contact-map">
        <div className="contact-map__placeholder">
          <MapPin size={48} />
          <h3>Find Us</h3>
          <p>Ashok Nagar, Chennai - 600 083, India</p>
          <a
            href="https://maps.google.com/?q=Ashok+Nagar+Chennai+600083"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline btn-sm"
          >
            Get Directions <ArrowRight size={14} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact;
